var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBannerNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4285 17.2019L15.4004 18.2381L13.8219 16.6596L9.95235 15L4.28569 17.4286V7.12337L1.85712 4.6948L2.89331 3.6667L16.4285 17.2019ZM15.619 14.32V4.47623C15.619 3.57765 14.8905 2.85718 14 2.85718H5.90474C5.42712 2.85718 5.00616 3.07575 4.69045 3.40765L15.619 14.32Z",
    fill: "#D5E3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBannerNo);
export default __webpack_public_path__ + "static/media/icn_banner_no.37ca30c71c666e9c4ce22f33129947e4.svg";
export { ForwardRef as ReactComponent };